import React from 'react'
import { SquareTile } from './SquareTile'
import { MaxWidthByDevice } from 'parameters/index'
import useResize from 'lib/hooks/useResize'
import { truncArray } from 'lib'
import { loanPurposeList } from 'experiences/explore/loans/ContentPage/content'
import { ListMargins } from 'experiences/explore/loans/components/NewLoanSearchWidget/styles'
import { InlineSvg } from 'components/patterns/icons/svg-tools/InlineSvg'
import { cnfSearchRedirectLink } from './config'
import { UrlObject } from 'url'

export interface LoanPurposeProps {
	title: string
	icon: string
	loanPurpose: string
}

const url = new URL(cnfSearchRedirectLink.search)
const destinationUrl: UrlObject = {
	protocol: url.protocol,
	host: url.host,
	hostname: url.hostname,
	pathname: url.pathname
}

export const LoanPurposeList: React.FC<React.PropsWithChildren<unknown>> = () => {
	const { width } = useResize()
	const isMobile = width <= MaxWidthByDevice.Tablet
	const loanPurposes = truncArray(loanPurposeList, isMobile ? 3 : 5)

	return (
		<>
			{loanPurposes.map(item => (
				<ListMargins key={item.title}>
					<SquareTile text={item.title} destination={destinationUrl}>
						<InlineSvg src={item.icon} width={32} height={32} />
					</SquareTile>
				</ListMargins>
			))}
		</>
	)
}
